import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { profileApi, type UserProfile, type UpdateProfilePayload } from '@/services/profile';

const PROFILE_KEY = ['profile'] as const;

export const useProfile = () => {
  return useQuery<UserProfile>({
    queryKey: PROFILE_KEY,
    queryFn: profileApi.get,
  });
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateProfilePayload) => profileApi.update(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(PROFILE_KEY, data);
    },
  });
};
